import * as Types from '../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as React from 'react';
import * as ApolloReactComponents from '@apollo/client/react/components';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
export type CreateOrderMutationVariables = Types.Exact<{
  enterpriseId: Types.Scalars['UUID'];
  customerId?: Types.InputMaybe<Types.Scalars['UUID']>;
  contact?: Types.InputMaybe<Types.ContactInput>;
  address: Types.AddressInput;
  invoiceAddress?: Types.InputMaybe<Types.AddressInput>;
  items: Array<Types.CartItemInput> | Types.CartItemInput;
  consentGtc: Types.Scalars['String'];
  consentAds?: Types.InputMaybe<Types.Scalars['String']>;
  comment?: Types.InputMaybe<Types.Scalars['String']>;
  sendNotificationMails?: Types.InputMaybe<Types.Scalars['Boolean']>;
  customerNumber?: Types.InputMaybe<Types.Scalars['String']>;
  discountParams?: Types.InputMaybe<Types.DiscountParamsInput>;
}>;

export type CreateOrderMutation = {
  __typename?: 'Mutation';
  adminCheckout: {
    __typename?: 'CalculatedOrderItemsWithTotal';
    orderId?: any | null;
  };
};

export const CreateOrderDocument = gql`
  mutation CreateOrder(
    $enterpriseId: UUID!
    $customerId: UUID
    $contact: ContactInput
    $address: AddressInput!
    $invoiceAddress: AddressInput
    $items: [CartItemInput!]!
    $consentGtc: String!
    $consentAds: String
    $comment: String
    $sendNotificationMails: Boolean
    $customerNumber: String
    $discountParams: DiscountParamsInput
  ) {
    adminCheckout(
      enterpriseId: $enterpriseId
      customerId: $customerId
      contact: $contact
      address: $address
      invoiceAddress: $invoiceAddress
      items: $items
      consentGtc: $consentGtc
      consentAds: $consentAds
      comment: $comment
      sendNotificationMails: $sendNotificationMails
      customerNumber: $customerNumber
      discountParams: $discountParams
    ) {
      orderId
    }
  }
`;
export type CreateOrderMutationFn = Apollo.MutationFunction<
  CreateOrderMutation,
  CreateOrderMutationVariables
>;
export type CreateOrderComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CreateOrderMutation,
    CreateOrderMutationVariables
  >,
  'mutation'
>;

export const CreateOrderComponent = (props: CreateOrderComponentProps) => (
  <ApolloReactComponents.Mutation<
    CreateOrderMutation,
    CreateOrderMutationVariables
  >
    mutation={CreateOrderDocument}
    {...props}
  />
);

/**
 * __useCreateOrderMutation__
 *
 * To run a mutation, you first call `useCreateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderMutation, { data, loading, error }] = useCreateOrderMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      customerId: // value for 'customerId'
 *      contact: // value for 'contact'
 *      address: // value for 'address'
 *      invoiceAddress: // value for 'invoiceAddress'
 *      items: // value for 'items'
 *      consentGtc: // value for 'consentGtc'
 *      consentAds: // value for 'consentAds'
 *      comment: // value for 'comment'
 *      sendNotificationMails: // value for 'sendNotificationMails'
 *      customerNumber: // value for 'customerNumber'
 *      discountParams: // value for 'discountParams'
 *   },
 * });
 */
export function useCreateOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateOrderMutation,
    CreateOrderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateOrderMutation, CreateOrderMutationVariables>(
    CreateOrderDocument,
    options,
  );
}
export type CreateOrderMutationHookResult = ReturnType<
  typeof useCreateOrderMutation
>;
export type CreateOrderMutationResult =
  Apollo.MutationResult<CreateOrderMutation>;
export type CreateOrderMutationOptions = Apollo.BaseMutationOptions<
  CreateOrderMutation,
  CreateOrderMutationVariables
>;
